import VueRouter, { RouteConfig } from 'vue-router'

const MovePracticeList = () => import('@/views/move-practice/List.vue')
const MovePracticeEditer = () => import('@/views/move-practice/Editer.vue')
const MovePracticeDetail = () => import('@/views/move-practice/Detail.vue')
const ClassDetail = () => import('@/views/move-practice/ClassDetail.vue')

const listRoute: RouteConfig = {
  path: '/move-practice-list',
  name: 'move_practice_list',
  component: MovePracticeList,
  meta: {
    title: '练习列表',
  },
}

const editerRoute: RouteConfig = {
  path: '/move-practice-editer',
  name: 'move_practice_editer',
  component: MovePracticeEditer,
  meta: {
    title: '练习信息',
  },
}

export const detailInfoRoute = {
  path: 'info',
  name: 'move_practice_detail_info',
  component: () => import('@/views/move-practice/components/DetailInfo.vue'),
}

const detailRoute: RouteConfig = {
  path: '/move-practice-detail',
  name: 'move_practice_detail',
  component: MovePracticeDetail,
  children: [
    detailInfoRoute,
    {
      path: 'stat',
      name: 'move_practice_detail_stat',
      component: () => import('@/views/move-practice/components/DetailStat.vue'),
    },
  ],
  meta: {
    title: '练习详情页',
  },
}

const classDetailRoute: RouteConfig = {
  path: '/move-practice-class-detail/:id/:cid',
  name: 'move_practice_class_detail',
  component: ClassDetail,
  props: true,
  meta: {
    title: '班级完成情况',
  },
}

export default [listRoute, editerRoute, detailRoute, classDetailRoute]

export function navigateToMovePracticeList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToMovePracticeEditer(router: VueRouter, id: number) {
  router.push({ name: editerRoute.name, query: id ? { id: '' + id } : {} })
}

export function navigateToMovePracticeDetail(router: VueRouter, id: number) {
  router.push({ name: detailRoute.children![0].name, query: { id: '' + id } })
}

export function navigateToMovePracticeDetailStat(router: VueRouter, id: number) {
  router.push({ name: detailRoute.children![1].name, query: { id: '' + id } })
}

export function navigateToMovePracticeClassDetail(router: VueRouter, id: number, classId: number) {
  router.push({ name: classDetailRoute.name, params: { id: id + '', cid: classId + '' } })
}
